<div class="circles">
  <li></li>
  <li></li>
  <li></li>
  <li></li>
</div>

<h1 class="SEO">Contact Me- Rahil Hastu</h1>
<section class="contact-page-section">
  <div class="contact-form">
    <span class="upend">&lt;end&gt;</span>
    <div class="title">
      <div class="contactme">
        <div class="contact">
          <span>C</span>
          <span>o</span>
          <span>n</span>
          <span>t</span>
          <span>a</span>
          <span>c</span>
          <span>t</span>
        </div>
        <div class="me">
          <span>&nbsp;</span>
          <span>M</span>
          <span>E</span>
          <span>!</span>
        </div>
      </div>
    </div>
    <span class="downend">&lt;/end&gt;</span>
    <div class="form">
      <form
        [formGroup]="contactForm"
        name="contact"
        class="col-10"
        id="contactForms"
        (ngSubmit)="onSubmit()"
      >
        <input
          class="form-element name"
          [ngClass]="
            name.invalid && (name.dirty || name.touched) ? 'wrong' : ''
          "
          type="text"
          placeholder="Name"
          formControlName="name"
          title="{{ formTitle.name }}"
          required
        />
        <input
          class="form-element email"
          [ngClass]="
            contactForm.get('email').invalid &&
            (contactForm.get('email').touched || contactForm.get('email').dirty)
              ? 'wrong'
              : ''
          "
          type="email"
          placeholder="Email"
          email="true"
          formControlName="email"
          title="{{ formTitle.email }}"
          required
        />
        <input
          class="form-element subject"
          [ngClass]="
            subject.invalid && (subject.dirty || subject.touched) ? 'wrong' : ''
          "
          type="text"
          placeholder="Subject"
          formControlName="subject"
          title="{{ formTitle.subject }}"
          required
        />
        <textarea
          class="form-element comment"
          [ngClass]="
            comment.invalid && (comment.dirty || comment.touched) ? 'wrong' : ''
          "
          placeholder="Comment"
          minlength="3"
          title="{{ formTitle.comment }}"
          formControlName="comments"
          required
        ></textarea>
        <button
          type="submit"
          [disabled]="!contactForm.valid"
          class="submit"
          value="Send"
        >
          Submit
        </button>
      </form>
      <div class="info"></div>
    </div>

    <span class="endHTML">&lt;/html&gt;</span>
  </div>
  <div class="contact-map">
    <div id="map"></div>
  </div>
</section>
